import React from "react";
import Modal from "react-bootstrap/Modal";

const DeleteModal = ({ show, handleClose, Id, header, description, comments }) => {
  const record = header === "Delete CCF Type"
    ? "type"
    : header === "Delete CCF Analysis"
      ? "analysis"
      : "CCF";

  return (
    <Modal show={show} size="md" onHide={() => handleClose("No", Id)}>
      <Modal.Header className="bg-danger text-white">
        <h3>{header}</h3>
      </Modal.Header>
      <Modal.Body>
        <h5 className="modalWrap">Are you sure you want to delete {record} {description}?</h5>
        <h5>{comments}</h5>
        <br></br>
        <br></br>
        <div className="row">
          <div className="col">
            <button
              className="btn btn-lg btn-success"
              onClick={() => handleClose("Yes", Id)}
            >
              Yes
            </button>
          </div>
          <div className="col">
            <button
              className="btn btn-lg btn-danger"
              onClick={() => handleClose("No")}
            >
              No
            </button>
          </div>
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default DeleteModal;
